var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.91374C0 4.0755 3.16707 0.963989 7.07385 0.963989H7.21727C8.46345 0.963989 9.47368 1.97422 9.47368 3.2204C9.47368 4.46658 8.46345 5.47681 7.21727 5.47681H7.07385C5.70394 5.47681 4.59341 6.56786 4.59341 7.91374V7.97476C4.59341 9.2432 3.56514 10.2715 2.29671 10.2715C1.02827 10.2715 0 9.2432 0 7.97476L0 7.91374Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8734 0.963989C20.7802 0.963989 23.9473 4.0755 23.9473 7.91374L23.9473 7.97476C23.9473 9.2432 22.919 10.2715 21.6506 10.2715C20.3821 10.2715 19.3539 9.2432 19.3539 7.97476L19.3539 7.91374C19.3539 6.56786 18.2433 5.47681 16.8734 5.47681L16.73 5.47681C15.4838 5.47681 14.4736 4.46658 14.4736 3.2204C14.4736 1.97422 15.4838 0.963989 16.73 0.963989L16.8734 0.963989Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9473 17.6292C23.9473 21.4675 20.7802 24.579 16.8734 24.579L16.73 24.579C15.4838 24.579 14.4736 23.5687 14.4736 22.3226C14.4736 21.0764 15.4838 20.0662 16.73 20.0662L16.8734 20.0662C18.2433 20.0662 19.3539 18.9751 19.3539 17.6292L19.3539 17.5682C19.3539 16.2998 20.3821 15.2715 21.6506 15.2715C22.919 15.2715 23.9473 16.2998 23.9473 17.5682L23.9473 17.6292Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07385 24.579C3.16707 24.579 -1.38437e-07 21.4675 -3.09208e-07 17.6292L-3.11923e-07 17.5682C-3.68358e-07 16.2998 1.02827 15.2715 2.29671 15.2715C3.56514 15.2715 4.59341 16.2998 4.59341 17.5682L4.59341 17.6292C4.59341 18.9751 5.70394 20.0662 7.07385 20.0662L7.21727 20.0662C8.46345 20.0662 9.47368 21.0764 9.47368 22.3226C9.47368 23.5687 8.46345 24.579 7.21727 24.579L7.07385 24.579Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.0700b57f.svg";
export { ForwardRef as ReactComponent };